import React from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";

let validationSchema = Yup.object({
   image: Yup.string().required("Slider image is Required."),
   link: Yup.string().required("Slider link is Required.").url("Invalid link."),
});

function AddSlider({ updateList, slider }) {
   return (
      <>
         <Formik
            initialValues={{
               image: slider?.image || "",
               link: slider?.link || "",
               isActive: slider?.isActive !== undefined ? slider.isActive : true,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = ""
                  if (slider?._id) {
                     let apiData = {
                        image: values.image,
                        link: values.link,
                        isActive: values.isActive,
                     }
                     res = await AppApi.updateSlider(apiData, slider?._id);
                  } else {
                     res = await AppApi.addSlider(values);
                  }
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                  }
                  resetForm();
                  updateList(res?.data?.data);
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form> 
                  <div className="categoryBannerWrapper">
                     {values.image && (
                        <img src={values.image} alt="" />
                     )}
                     <div className="uploadBannerWrapper"
                        onClick={() => {
                           document.getElementById("uploadImage").click();
                        }}
                     >
                        <i className='fas fa-upload'></i>
                        <input
                           type="file"
                           id="uploadImage"
                           onChange={async (e) => {
                              if (e.target.value) {
                                 let file = e.currentTarget.files[0]
                                 if (file.type.split("/")[0] === "image") {
                                    let filePath = await gallery.uploadFile(file, "SLIDERS");
                                    if (filePath) {
                                       setFieldValue("image", filePath)
                                    }
                                 } else {
                                    toast.error("This file is not allowed to upload.");
                                 }
                              } else {
                                 toast.error("No file found to upload.");
                              }
                           }}
                           className="d-none"
                        />
                     </div>
                  </div>
                  <ErrorMessage component="small" className='text-danger' name="image" />
                  <div className="d-flex mt-1">
                     <div className="form-group flex-grow-1 ms-2">
                        <label>Link</label>
                        <Field
                           name="link"
                           type="text"
                           className="form-control rounded"
                           placeholder="Url"
                        />
                        <ErrorMessage component="small" className='text-danger' name="link" />
                     </div>
                  </div>
                  {slider?._id && (
                     <div className="form-check mt-2">
                        <Field name="isActive" className="form-check-input" type="checkbox" id="sliderStatus" />
                        <label className="form-check-label" htmlFor="sliderStatus">
                           Slider status
                        </label>
                     </div>
                  )}
                  <div className="p-0 mt-5 text-left col-sm-12">
                     <div className="mb-1 form-group">
                        <button type="submit" disabled={isSubmitting} className="w-100 btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : slider?._id ? "Update" : "Add"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
         <br />
         <br />
         <br />
         {slider?._id && (
            <div className="d-flex justify-content-end">
               <button className='btn btn-danger rounded-0'
                  onClick={async () => {
                     let apiData = {
                        isDeleted: true,
                        image: slider?.image,
                        link: slider?.link,
                     }
                     let res = await AppApi.updateSlider(apiData, slider?._id);
                     if (res?.data?.error == false) {
                        toast.success("Slider deleted successfully.");
                        updateList(slider, true);
                     }

                  }}
               ><i className='fas fa-trash'></i> Delete  </button>
            </div>
         )}
      </>
   )
}

export default AddSlider